import moment from "moment";

export const birthValidation = (inputDate: string) => {
  const initialDate = moment(inputDate,  "DD/MM/YYYY");
  const todayDate = moment();
  const diff = todayDate.diff(initialDate);
  const age = moment.duration(diff);
  
  return (age.asYears() >= 18);
};